export const iconFontAwesomeGamingChessKing = (
	<i className="fa-solid fa-chess-king"></i>
);
